import * as constants from './constants';

export const getStorages = (payload) => ({ type: constants.GET_STORAGES, payload });
export const getStoragesSuccess = (payload) => ({
  type: constants.GET_STORAGES_SUCCESS,
  payload,
});
export const getStoragesError = (payload) => ({
  type: constants.GET_STORAGES_ERROR,
  payload,
});

export const resetStorages = () => ({ type: constants.RESET_STORAGES });
